import { Advertise } from '../../../store/advertise/api/interface';

export function csv(data: Advertise[]) {
  const result = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    result.push({
      number: element?.advertiseNumber,
      user: element?.createdByUser?.name,
      title: element?.title,
      description: element?.description,
      category: element?.property_category?.labelEn,
      subCategory: element?.property_sub_category?.labelEn,
      possessionType: element?.property_possession_type?.labelEn,
      price: element?.price,
      status: element?.status,
      address: `${element?.address},Building Number: ${element?.buildingNumber ?? ''}, Street Number: ${element?.streetNumber ?? ''}, Zone Number: ${element?.zoneNumber ?? ''}, Zip Code: ${element?.zipCode ?? ''}.`,
    });
  }

  return result;
}